const styles = (page, territory) => {
  const userType = window.location.pathname.includes('hosts') ? 'host' : 'guest'
  const background = territory[`${userType}_background`]
  const addressBackground = `/assets/${userType}_address_background.jpg`

  const layout = {
    backgroundImage: `url('${page == 'address' ? addressBackground : background}')`
  }

  const container = page == 'address'
    ? {
        display: 'flex',
        flexFlow: 'column',
        justifyContent: 'center',
        height: '100%'
      }
    : {}

  return { layout, container }
}

export default styles
